module.exports = __webpack_public_path__ + "media/customizations/blackwoodgroves/logo-new-71d71c5fb91c4954fafee9f65ae90449.png";